<template>
    <div class="col-12 col-sm-6 col-md-4 my-2 app-card-filtered">
        <div class="app-card app-card-branded app-card-background">
            <!-- Head -->
            <div class="app-card-head">
                <span class="app-badge app-card-badge bg-ship-gray text-white">
                    <span class="app-badge-text">{{ offre.badge }}</span>
                </span>
                <img alt="" class="app-card-image" height="210" :src="offre.image" :srcset="offre.imageset" width="300">
            </div>

            <!-- Body -->
            <div class="app-card-body">

                <h3 class="app-card-title text-secondary text-uppercase">
                    <a class="app-card-link" :href="offre.url">{{ offre.title }}</a>
                </h3>
                <div class="app-card-richtext app-richtext">
                    <p><strong v-html="offre.description"></strong></p>
                </div>
            </div>

            <!-- Foot -->
            <div class="app-card-foot">
                <a :href="offre.url" class="app-link app-card-more">
                    <span class="app-link-text text-secondary">Découvrir cette offre</span> <span class="app-link-icon">→</span>
                </a>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "OffreComponent",
        props: ['offre']
    }
</script>

<style scoped>

</style>
